import financasRotas from './routes/financas.rotas'
import pagarBarbeiroRotas from './routes/pagarbarbeiro.rotas'
import usuariosRotas from './routes/usuarios.rotas'
import filiaisRotas from './routes/filiais.rotas'
import servicosRotas from './routes/servicos.rotas'
import descontosRotas from './routes/descontos.rotas'
import produtosRotas from './routes/produtos.rotas'
import entradasRotas from './routes/entradas.rotas'
import estoqueRotas from './routes/estoque.rotas'
import atendimentosRotas from './routes/atendimentos.rotas'

// eslint-disable-next-line
export const rotasAdministrativo = {
  modulo: 'administrativo',
  label: 'Administrativo',
  icon: 'user-tie',
  mostrarMenu: true,
  rotas: [...financasRotas, ...pagarBarbeiroRotas,
    ...usuariosRotas, ...filiaisRotas, ...descontosRotas,
    ...servicosRotas, ...produtosRotas, ...entradasRotas,
    ...estoqueRotas, ...atendimentosRotas],
}
